import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { Container, Button, Row, Col, Table, Form, Spinner } from 'react-bootstrap';
import EditNoteIcon from '@mui/icons-material/EditNote';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';

const UserFragment = () => {
    const [courses, setCourses] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        email: '',
        type: 'admin',
        company: '',
        permissions: [] // New state for permissions
    });
    const [isEdit, setIsEdit] = useState(false);

    useEffect(() => {
        fetchCompanies();
    }, []);


    useEffect(() => {
        fetchUsers(currentPage);
    }, [currentPage]);



    const fetchUsers = async (page) => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", localStorage.getItem('token'));
        const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow"
        };
        let apiUrl = `https://beiguru.co.in/admin/all-users?page=${currentPage}&pageSize=10`;
        fetch(apiUrl, requestOptions)
            .then(response => {
                if (response.status === 401) {
                    localStorage.clear();
                    window.location.reload();
                    return [];
                } else {
                    return response.json();
                }
            })
            .then(result => {
                setCourses(result.users);
                setTotalPage(result.totalPages);
            })
            .catch(error => console.error(error));
    };

    const fetchCompanies = async () => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", localStorage.getItem('token'));
        const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow"
        };
        fetch("https://beiguru.co.in/admin/companies", requestOptions)
            .then((response) => {
                if (response.status == 401) {
                    localStorage.clear();
                    window.location.reload();
                    return [];
                } else {
                    return response.json()
                }
            })
            .then((result) => setCompanies(result))
            .catch((error) => console.error(error));
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setIsLoading(true);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", localStorage.getItem('token'));
            myHeaders.append("Content-Type", "application/json");
            const raw = JSON.stringify({
                "username": formData.email,
                "company": formData.type == 'admin' ? formData.company : null,
                "type": formData.type,
                "permissions": formData.type == 'bcom' ? formData.permissions : []
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            await fetch("https://beiguru.co.in/admin/register-user", requestOptions)
                .then((response) => {
                    if (!response.ok) {
                        alert('Failed to create user, please try again!!');
                        throw new Error('Failed to upload user');
                    }
                    else {
                        alert('User created successfully!!');

                    }
                })
                .catch((error) => console.error(error));
            fetchUsers();
            setIsLoading(false);
            setFormData({
                email: '',
                type: 'admin',
                company: '',
                permissions: [] // New state for permissions
            });
        } catch (error) {
            alert('Failed to create user, please try again!!');
            setIsLoading(false);
        }
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            setIsLoading(true);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", localStorage.getItem('token'));
            myHeaders.append("Content-Type", "application/json");
            const raw = JSON.stringify({
                "username": formData.email,
                "company": formData.type == 'admin' ? formData.company : null,
                "type": formData.type,
                "permissions": formData.type == 'bcom' ? formData.permissions : []
            });

            const requestOptions = {
                method: "PUT",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            console.log(formData.usesrIdToUpdate);
            const response = await fetch(`https://beiguru.co.in/admin/users/${formData.usesrIdToUpdate}`, requestOptions);

            if (!response.ok) {
                throw new Error('Failed to update user');
            }
            setFormData({
                email: '',
                type: 'admin',
                company: '',
                permissions: [] // New state for permissions
            });
            alert('User updated successfully!');
            fetchUsers();
            setIsEdit(false);
            setIsLoading(false);
        } catch (error) {
            console.log();
            alert('Failed to update user, please try again!');
            setIsLoading(false);
        }
    };

    const handleFileChange = (e) => {
        setFormData({ ...formData, thumbnail: e.target.files[0] });
    };

    const handleEdit = (course) => {
        setFormData({
            usesrIdToUpdate: course._id,
            email: course.username,
            type: course.type,
            company: course.type == 'admin' ? course.company._id : null,
            permissions: course.permissions
        });
        setIsEdit(true);
    };

    const handleDelete = async (userID) => {
        // Display confirmation popup before deleting
        const isConfirmed = window.confirm("Are you sure you want to delete this user?");
        if (!isConfirmed) return; // If user cancels, do nothing

        try {
            const token = localStorage.getItem('token'); // Get the authentication token
            const requestOptions = {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', 'Authorization': token },
            };

            const response = await fetch(`https://beiguru.co.in/admin/delete-user/${userID}`, requestOptions);

            if (response.ok) {
                alert('User deleted successfully');
                fetchUsers();
            } else {
                alert('Failed to delete user');
            }
        } catch (error) {
            console.error('Error deleting user:', error);
            alert('Failed to delete user');
        }
    };

    // Function to handle changes in permissions
    const handlePermissionsChange = (e) => {
        const { value } = e.target;
        let updatedPermissions = [...formData.permissions];

        if (updatedPermissions.includes(value)) {
            updatedPermissions = updatedPermissions.filter(permission => permission !== value);
        } else {
            updatedPermissions.push(value);
        }

        setFormData({ ...formData, permissions: updatedPermissions });
    };

    function capitalizePermissions(permissions) {
        return permissions.map(permission => {
            return ' ' + permission.charAt(0).toUpperCase() + permission.slice(1);
        });
    }

    return (
        <Grid item xs={10} style={{ padding: '20px', height: '100%', fontFamily: "Noto Sans", fontWeight: '500', justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
            <Container fluid style={{ height: '100%' }}>
                <Row>
                    <Col xs={8} style={{ height: '90vh', display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'start' }}>
                        {courses.length > 0 ? <table className="table table-striped table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th>User</th>
                                    <th>Type</th>
                                    <th>School/Permission</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {/* Map through courses data to display each course */}
                                {courses.map(course => (
                                    <tr key={course._id}>
                                        <td>{course.username}</td>
                                        <td>{course.type == 'admin' || course.type == 'owner' ? 'School Admin' : 'BCOM Team'}</td>
                                        <td style={{ fontWeight: course.type == 'admin' || course.type == 'owner' ? 'bold' : '' }}>{course.type == 'admin' || course.type == 'owner' ? course.company ? course.company.name : '' : capitalizePermissions(course.permissions).toString()}</td>
                                        <td>
                                            <EditNoteIcon onClick={() => handleEdit(course)} style={{ color: 'green', cursor: 'pointer' }} />
                                            <DeleteSweepIcon onClick={() => handleDelete(course._id)} style={{ color: 'red', cursor: 'pointer' }} />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table> : <div style={{ flex: 1, textAlign: 'center' }}>No users found, please try again!</div>}
                        <div style={{ flex: 1 }}></div>
                        <nav aria-label="Courses pagination">
                            <ul className="pagination">
                                {[...Array(totalPage).keys()].map((page) => (
                                    <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                                        <button className="page-link" onClick={() => handlePageChange(page + 1)}>
                                            {page + 1}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    </Col>
                    {/* Form to Add a School (40% width) */}
                    <Col xs={4}>
                        <h4 style={{ marginTop: '15px' }}>{isEdit ? 'Modify' : 'Create'} User</h4>
                        <Form style={{ fontFamily: "Noto Sans" }} className="w-100" onSubmit={isEdit ? handleUpdate : handleSubmit}>
                            <Form.Group controlId="formEmail">
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Email</Form.Label>
                                <Form.Control
                                    className="w-100"
                                    style={{ width: '100%', borderRadius: '20px' }}
                                    type="text"
                                    placeholder="Enter email"
                                    value={formData.email}
                                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group controlId="formType" style={{ marginTop: '10px', flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px', marginRight: '10px' }}>Type:</Form.Label>
                                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                    <Form.Check
                                        type="radio"
                                        label="School Admin"
                                        name="type"
                                        value="admin"
                                        checked={formData.type === "admin"}
                                        onChange={(e) => setFormData({ ...formData, type: e.target.value })}
                                        style={{ marginRight: '10px' }}
                                    />
                                    <Form.Check
                                        type="radio"
                                        label="BCOM Team"
                                        name="type"
                                        value="bcom"
                                        checked={formData.type === "bcom"}
                                        onChange={(e) => setFormData({ ...formData, type: e.target.value })}
                                        style={{ marginRight: '10px' }}
                                    />
                                </div>
                            </Form.Group>
                            <Form.Group controlId="formCompany">
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>School</Form.Label>
                                <Form.Control
                                    className="w-100"
                                    style={{ width: '100%', borderRadius: '20px' }}
                                    as="select"
                                    value={formData.company}
                                    onChange={(e) => setFormData({ ...formData, company: e.target.value })}>
                                    <option value="">Select a school</option>
                                    {companies.map(company => (
                                        <option key={company._id} value={company._id}>{company.name}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                            <Form.Group controlId="permissions" style={{ marginTop: '10px' }}>
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Permissions:</Form.Label>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gridColumnGap: '10px' }}>
                                    <div>
                                        <Form.Check
                                            type="checkbox"
                                            label="All"
                                            name="permissions"
                                            value="all"
                                            checked={formData.permissions.includes("all")}
                                            onChange={(e) => handlePermissionsChange(e)}
                                            style={{ marginTop: '5px' }}
                                        />
                                        <Form.Check
                                            type="checkbox"
                                            label="Dashboard"
                                            name="permissions"
                                            value="dashboard"
                                            checked={formData.permissions.includes("dashboard")}
                                            onChange={(e) => handlePermissionsChange(e)}
                                            style={{ marginTop: '5px' }}
                                        />
                                        <Form.Check
                                            type="checkbox"
                                            label="Students"
                                            name="permissions"
                                            value="employee"
                                            checked={formData.permissions.includes("employee")}
                                            onChange={(e) => handlePermissionsChange(e)}
                                            style={{ marginTop: '5px' }}
                                        />
                                        <Form.Check
                                            type="checkbox"
                                            label="Course"
                                            name="permissions"
                                            value="course"
                                            checked={formData.permissions.includes("course")}
                                            onChange={(e) => handlePermissionsChange(e)}
                                            style={{ marginTop: '5px' }}
                                        />
                                        <Form.Check
                                            type="checkbox"
                                            label="Quiz"
                                            name="permissions"
                                            value="quiz"
                                            checked={formData.permissions.includes("quiz")}
                                            onChange={(e) => handlePermissionsChange(e)}
                                            style={{ marginTop: '5px' }}
                                        />
                                    </div>
                                    <div>
                                        <Form.Check
                                            type="checkbox"
                                            label="Rating"
                                            name="permissions"
                                            value="rating"
                                            checked={formData.permissions.includes("rating")}
                                            onChange={(e) => handlePermissionsChange(e)}
                                            style={{ marginTop: '5px' }}
                                        />
                                        <Form.Check
                                            type="checkbox"
                                            label="Answers"
                                            name="permissions"
                                            value="answers"
                                            checked={formData.permissions.includes("answers")}
                                            onChange={(e) => handlePermissionsChange(e)}
                                            style={{ marginTop: '5px' }}
                                        />
                                        <Form.Check
                                            type="checkbox"
                                            label="Survey"
                                            name="permissions"
                                            value="survey"
                                            checked={formData.permissions.includes("survey")}
                                            onChange={(e) => handlePermissionsChange(e)}
                                            style={{ marginTop: '5px' }}
                                        />
                                        <Form.Check
                                            type="checkbox"
                                            label="Info"
                                            name="permissions"
                                            value="info"
                                            checked={formData.permissions.includes("info")}
                                            onChange={(e) => handlePermissionsChange(e)}
                                            style={{ marginTop: '5px' }}
                                        />
                                        <Form.Check
                                            type="checkbox"
                                            label="Notification"
                                            name="permissions"
                                            value="notification"
                                            checked={formData.permissions.includes("notification")}
                                            onChange={(e) => handlePermissionsChange(e)}
                                            style={{ marginTop: '5px' }}
                                        />
                                    </div>
                                </div>
                            </Form.Group>
                            <Button
                                style={{ fontWeight: '600', borderRadius: '20px', marginTop: '15px' }}
                                elevation={3}
                                className="w-100"
                                variant="primary"
                                type="submit"
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                ) : null}
                                {isEdit ? 'Modify' : 'Create'} User
                            </Button>
                        </Form>
                    </Col>
                </Row>
            </Container>
        </Grid >
    );
}

export default UserFragment;